import React from 'react'

import MenuSecundario from './MenuSecundario'
import RedesSociales from './RedesSociales'
import SitiosRelacionados from './SitiosRelacionados'

import '../../../styles/pie-pagina.css'
import { Row } from 'antd'

/*import { UserOutlined } from '@ant-design/icons'*/

const PieDePagina = ({english}) => {
    return(
        <div className="contenedor">
            <MenuSecundario english={english} />
            <RedesSociales />
            <Row align="middle" justify="center" className="logo">
                <img alt="" src="/images/cabo-marques-acapulco-guerrero.jpg" />
            </Row>
            <SitiosRelacionados />
        </div>
    )
}

export default PieDePagina